import moment from 'moment';

class UtilsService {
    toastTimer = null;

    showToast(msg, type = 'success', duration = 5000) {
        const id = 'gsb-toast';
        const toast = document.getElementById(id);
        if (toast != null) {
            this.toastTimer != null && clearTimeout(this.toastTimer);
            toast.outerHTML = '';
        }

        let textType = '';

        switch (type) {
            case 'success':
                textType = 'primary';
                break;
            case 'warning':
                textType = 'warning';
                break;
            default:
                textType = 'danger';
        }

        const bgClass = `text-${textType}`;
        const tooltip = `
            <div id="${id}" class="position-fixed bottom-0 end-0 p-3" style="z-index: 9999">
                <div
                    class="toast show"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    style="background: #333"
                >
                    <div class="toast-body">
                        <b class="text-uppercase font-size-18 ${bgClass}">${type}</b>
                        <div class="text-white font-size-15 fw-light">${msg || ''}<div>
                    </div>
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML('beforeend', tooltip);

        this.toastTimer = setTimeout(() => (document.getElementById(id).outerHTML = ''), duration);
    }

    toJS = obj => {
        return obj ? JSON.parse(JSON.stringify(obj)) : obj;
    };

    addParamsToUrl = (url, data, useEncode) => {
        if (data) {
            var params = [];
            for (let key in data) {
                if (key && data[key] != null && data[key] !== '') {
                    let value = useEncode === false ? data[key] : encodeURIComponent(data[key]);
                    params.push(`${key}=${value}`);
                }
            }

            if (params.length) {
                const symbol = url.indexOf('?') >= 0 ? '&' : '?';
                url = `${url}${symbol}${params.join('&')}`;
            }
        }

        return url;
    };

    isNumber = num => num != null && num !== '' && !isNaN(num);

    getEnumValues = (value = {}, valuePropName, textPropName) => {
        return Object.keys(value)
            .filter(key => !isNaN(value[key]))
            .map(key => {
                let item = value[key];
                const valueKey = valuePropName || 'value';
                const textKey = textPropName || 'text';

                return {
                    [valueKey]: item,
                    [textKey]: value[item]
                };
            });
    };

    keyToLabel = (key = '') => {
        return key.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
    };

    uuid = () => Date.now().toString(36) + Math.random().toString(36).substring(2);

    containsSafe = (str, query) => (str || '').toLowerCase().includes((query || '').toLowerCase());

    dateFormat = (date, format) => {
        if (date) {
            if (typeof date === 'string' && date[date.length - 1] === 'Z') {
                return moment(date)
                    .utc(false)
                    .format(format || 'L');
            }

            return moment(date).format(format || 'L');
        }

        return null;
    };
}

export default new UtilsService();
